/**
 * Unthemed component
 */ export const ThemedTabs = {
    defaultProps: {
        colorScheme: 'primary'
    }
};

//# sourceMappingURL=Tabs.js.map